import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { connect } from "react-redux";
import classNames from "classnames";
import "./index.scss";
import {Popover} from 'antd';

import { createAction } from "../../../utils/sagaHelper";

import IconButton from "../IconButton";
import {isRTL} from "../../../services/userModel.js";

const CommentEditor = ({ t, itemAction, id, value, action, tooltipText, placeholder }) => {
    const [open, setOpen] = useState(false);
    const [currentValue, setCurrentValue] = useState(value);

    const handleOnSetNote = () => {
        return new Promise((resolve, reject)=> {
            if(action) {
                itemAction(action, { id, value: currentValue }).then(()=> {
                    resolve();
                    setOpen(false);
                }, error=> {
                    reject();
                    toast.error(error || "Error");                    
                });
            } else {
                reject();
                toast.error("No actions");                
            }
        });                
    }

    const handleOnCancel = () => {
        return new Promise(resolve=> {
            resolve();
            setOpen(false);
            setCurrentValue(value);
        });                
    }

    const handleOnSetOpen = () => {
        return new Promise(resolve=> {
          resolve();
          setOpen(!open);
        });    
    }

    return (
        <div className={classNames("commentEditor")}>
            <Popover
                placement={isRTL() ? "right" : "left"}
                content={<div className={classNames("commentPopover", {rtl: isRTL()})}>
                    <textarea value={currentValue} placeholder={placeholder}
                              className={classNames("inputItem")}
                              onChange={e=> setCurrentValue(e.target.value)}
                    ></textarea>
                    <div className={classNames("controls")}>
                        <button className={classNames("btn", "confirm")} disabled={!currentValue?.length} onClick={handleOnSetNote}>
                            {t("basic.SAVE_BUTTON")}
                        </button>
                        <button className={classNames("btn", "denied")} onClick={handleOnCancel}>
                            {t("basic.CANCEL_BUTTON")}
                        </button>
                    </div>
                </div>}
                trigger="click"
                open={open}
                onOpenChange={setOpen}
            />
            <IconButton
                isIcon={true}
                iconName={value ? "noteActive": "note"}
                tooltipText={tooltipText}
                onClick={handleOnSetOpen}
            />
        </div>
    );
}

const mapDispatchToProps = dispatch => {
    return {
        itemAction: (action, data) => dispatch(createAction(action, data)),
    };
};

export default connect(null, mapDispatchToProps)(withTranslation()(CommentEditor));